import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styled from 'styled-components';
import { getSize } from '@lib/common';
import { useMemo, useState } from 'react';
import { useQuestionContext } from '../../../../core';
import { CloseOutlined } from '@ant-design/icons'; // Styled component should be a regular span, not NodeViewWrapper

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledFillInBlankNode = styled.span.withConfig({
  displayName: "fill-in-blankextension__StyledFillInBlankNode",
  componentId: "sc-3cj8ql-0"
})(["display:inline-flex;align-items:center;justify-content:center;padding:0 ", ";margin:", " ", ";background-color:#dbeafe;color:#2563eb;border-radius:", ";font-size:", ";font-weight:700;white-space:nowrap;user-select:none;cursor:pointer;border:1px solid #bfdbfe;position:relative;pointer-events:auto;transition:all 0.2s ease;&:hover{background-color:#bfdbfe;transform:translateY(-1px);}&:active{transform:translateY(0);}"], getSize('padding8'), getSize('padding4'), getSize('padding8'), getSize('radiusS'), getSize('typo14'));
var StyledDeleteButton = styled.button.withConfig({
  displayName: "fill-in-blankextension__StyledDeleteButton",
  componentId: "sc-3cj8ql-1"
})(["position:absolute;top:-8px;right:-8px;width:14px;height:14px;border-radius:50%;border:1px solid #ef4444;background-color:white;color:#ef4444;display:", ";align-items:center;justify-content:center;cursor:pointer;padding:0;font-size:", ";line-height:1;transition:all 0.2s ease;z-index:10;box-shadow:0 1px 3px rgba(0,0,0,0.1);&:hover{background-color:#ef4444;color:white;transform:scale(1.1);}&:active{transform:scale(0.95);}"], function (_ref) {
  var $isVisible = _ref.$isVisible;
  return $isVisible ? 'flex' : 'none';
}, getSize('typo12'));

var FillInBlankNodeComponent = function FillInBlankNodeComponent(_ref2) {
  var _fibQuestion$answers$, _fibQuestion$answers;

  var node = _ref2.node,
      getPos = _ref2.getPos,
      editor = _ref2.editor,
      deleteBlank = _ref2.deleteBlank,
      onBlankClick = _ref2.onBlankClick;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1]; // Get answers count to trigger re-calculation when answers change (e.g., after delete)


  var fibQuestion = question;
  var answersCount = (_fibQuestion$answers$ = fibQuestion === null || fibQuestion === void 0 ? void 0 : (_fibQuestion$answers = fibQuestion.answers) === null || _fibQuestion$answers === void 0 ? void 0 : _fibQuestion$answers.length) !== null && _fibQuestion$answers$ !== void 0 ? _fibQuestion$answers$ : 0; // Serialize answers IDs to ensure proper re-calculation when answers change
  // This is needed because React uses shallow comparison for dependencies

  var answersIds = useMemo(function () {
    var _fibQuestion$answers2;

    return (fibQuestion === null || fibQuestion === void 0 ? void 0 : (_fibQuestion$answers2 = fibQuestion.answers) === null || _fibQuestion$answers2 === void 0 ? void 0 : _fibQuestion$answers2.map(function (a) {
      return a.id.toString();
    }).join(',')) || '';
  }, [fibQuestion === null || fibQuestion === void 0 ? void 0 : fibQuestion.answers]); // Calculate blank index based on answers array (source of truth)
  // This ensures blanks are always in sync with answers since delete flows: Answer section → Editor
  // and ensures blank indexes match question index range (e.g., Question 1-3 → Blank 1, 2, 3)

  var displayIndex = useMemo(function () {
    var _question$index;

    var questionIndex = (_question$index = question === null || question === void 0 ? void 0 : question.index) !== null && _question$index !== void 0 ? _question$index : 1; // question.index is 1-based for display

    var blankId = node.attrs.id; // Use answers array as source of truth

    var answers = (fibQuestion === null || fibQuestion === void 0 ? void 0 : fibQuestion.answers) || []; // Find the position of this blank ID in answers array

    var answerIndex = answers.findIndex(function (a) {
      return a.id.toString() === blankId;
    }); // If not found in answers, this blank was deleted - return -1 to hide it

    if (answerIndex === -1) {
      console.warn("[Blank] ID ".concat(blankId.substring(0, 8), "... not found in answers array - was deleted"));
      return -1;
    } // Display index = question start index + position in answers array


    var calculatedIndex = questionIndex + answerIndex;
    return calculatedIndex;
  }, [question === null || question === void 0 ? void 0 : question.index, node.attrs.id, answersCount, // Trigger when count changes
  answersIds // Trigger when answers IDs change (serialized for proper comparison)
  ]);

  var handleClick = function handleClick() {
    if (onBlankClick) {
      onBlankClick(node.attrs.id);
    }
  };

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    e.preventDefault();
    var blankId = node.attrs.id;

    if (deleteBlank) {
      // Get position of this node to select it before deleting
      var pos = getPos(); // Delete the node from editor first using deleteNode command
      // Set node selection first to ensure we delete the correct node

      editor.chain().focus().setNodeSelection(pos).deleteNode('fillInBlank').run(); // Then call deleteBlank to update description and answers

      deleteBlank(blankId);
      setTimeout(function () {
        var currentPos = editor.state.selection.$anchor.pos;
        editor.chain().insertContent(' ').deleteRange({
          from: currentPos,
          to: currentPos + 1
        }).run();
      }, 50); // Small delay to ensure description is updated
    }
  }; // Don't render if blank was deleted (not in answers array)


  if (displayIndex === -1) {
    return null;
  }

  return /*#__PURE__*/_jsx(NodeViewWrapper, {
    as: "span",
    children: /*#__PURE__*/_jsxs(StyledFillInBlankNode, {
      onClick: handleClick,
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      children: ["[Blank ", displayIndex, "]", deleteBlank && /*#__PURE__*/_jsx(StyledDeleteButton, {
        $isVisible: isHovered,
        onClick: handleDelete,
        type: "button",
        "aria-label": "Delete blank",
        children: /*#__PURE__*/_jsx(CloseOutlined, {
          style: {
            fontSize: '8px'
          }
        })
      })]
    })
  });
};

export var FillInBlankExtension = Node.create({
  name: 'fillInBlank',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  // Prevent selection and deletion
  draggable: false,
  // Prevent drag and drop
  addOptions: function addOptions() {
    return {
      deleteBlank: undefined,
      onBlankClick: undefined
    };
  },
  addAttributes: function addAttributes() {
    return {
      id: {
        "default": null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('id');
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes.id) {
            return {};
          }

          return {
            id: attributes.id
          };
        }
      },
      index: {
        "default": null
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'fib-blank',
      getAttrs: function getAttrs(node) {
        if (typeof node === 'string') return false;
        var element = node;
        return {
          id: element.getAttribute('id')
        };
      }
    }];
  },
  renderHTML: function renderHTML(_ref3) {
    var HTMLAttributes = _ref3.HTMLAttributes;
    return ['fib-blank', mergeAttributes(HTMLAttributes)];
  },
  addNodeView: function addNodeView() {
    var _this = this;

    return ReactNodeViewRenderer(function (props) {
      return /*#__PURE__*/_jsx(FillInBlankNodeComponent, _objectSpread(_objectSpread({}, props), {}, {
        deleteBlank: _this.options.deleteBlank,
        onBlankClick: _this.options.onBlankClick
      }));
    }, {
      // Ensure the node view is properly rendered
      contentDOMElementTag: 'span'
    });
  },
  // Prevent deletion of blank nodes via keyboard
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      Backspace: function Backspace() {
        var state = _this2.editor.state;
        var selection = state.selection;
        var $anchor = selection.$anchor; // Check if we're trying to delete a fillInBlank node

        var nodeBefore = $anchor.nodeBefore;

        if (nodeBefore && nodeBefore.type.name === 'fillInBlank') {
          return true; // Prevent deletion
        } // Check if selection includes fillInBlank nodes (e.g., Ctrl+A -> Delete)


        if (!selection.empty) {
          var from = selection.from,
              to = selection.to;
          var foundFillInBlank = false;
          state.doc.nodesBetween(from, to, function (node) {
            if (node.type.name === 'fillInBlank') {
              foundFillInBlank = true;
              return false; // Stop traversing
            }
          });

          if (foundFillInBlank) {
            return true; // Prevent deletion
          }
        }

        return false;
      },
      Delete: function Delete() {
        var state = _this2.editor.state;
        var selection = state.selection;
        var $anchor = selection.$anchor; // Check if we're trying to delete a fillInBlank node

        var nodeAfter = $anchor.nodeAfter;

        if (nodeAfter && nodeAfter.type.name === 'fillInBlank') {
          return true; // Prevent deletion
        } // Check if selection includes fillInBlank nodes (e.g., Ctrl+A -> Delete)


        if (!selection.empty) {
          var from = selection.from,
              to = selection.to;
          var foundFillInBlank = false;
          state.doc.nodesBetween(from, to, function (node) {
            if (node.type.name === 'fillInBlank') {
              foundFillInBlank = true;
              return false; // Stop traversing
            }
          });

          if (foundFillInBlank) {
            return true; // Prevent deletion
          }
        }

        return false;
      },
      // Prevent Cut operation (Ctrl+X / Cmd+X)
      'Mod-x': function ModX() {
        var state = _this2.editor.state;
        var selection = state.selection; // If nothing selected, check node before/after cursor

        if (selection.empty) {
          var $anchor = selection.$anchor;
          var nodeBefore = $anchor.nodeBefore;
          var nodeAfter = $anchor.nodeAfter;

          if (nodeBefore && nodeBefore.type.name === 'fillInBlank' || nodeAfter && nodeAfter.type.name === 'fillInBlank') {
            return true; // Prevent cut
          }
        } // If selection includes fillInBlank nodes, prevent cut


        if (!selection.empty) {
          var from = selection.from,
              to = selection.to;
          var foundFillInBlank = false;
          state.doc.nodesBetween(from, to, function (node) {
            if (node.type.name === 'fillInBlank') {
              foundFillInBlank = true;
              return false; // Stop traversing
            }
          });

          if (foundFillInBlank) {
            return true; // Prevent cut
          }
        }

        return false;
      },
      // Prevent undo/redo to avoid restoring deleted blanks
      // Blanks should only be deleted via the answers section delete button
      'Mod-z': function ModZ() {
        // Prevent undo if document contains fillInBlank nodes
        var state = _this2.editor.state;
        var hasFillInBlank = false;
        state.doc.descendants(function (node) {
          if (node.type.name === 'fillInBlank') {
            hasFillInBlank = true;
            return false; // Stop traversing
          }
        }); // Prevent undo when there are blank nodes to protect them

        return hasFillInBlank;
      },
      // Prevent redo (Shift+Mod+z)
      'Shift-Mod-z': function ShiftModZ() {
        var state = _this2.editor.state;
        var hasFillInBlank = false;
        state.doc.descendants(function (node) {
          if (node.type.name === 'fillInBlank') {
            hasFillInBlank = true;
            return false;
          }
        });
        return hasFillInBlank;
      },
      // Prevent redo (Mod+y) - alternative shortcut on Windows
      'Mod-y': function ModY() {
        var state = _this2.editor.state;
        var hasFillInBlank = false;
        state.doc.descendants(function (node) {
          if (node.type.name === 'fillInBlank') {
            hasFillInBlank = true;
            return false;
          }
        });
        return hasFillInBlank;
      }
    };
  }
});